import { registerQuery } from 'data-fetching-client';
import { getInvoiceEmailSettings } from '../api/SettingsAPI';
export const FETCH_INVOICE_EMAIL_SETTINGS = registerQuery({
  fieldName: 'emailSettings',
  fetcher: getInvoiceEmailSettings
});